module.exports = __webpack_public_path__ + "static/media/holding-apple-cut1.694d08cc.jpeg";